export default __webpack_public_path__ + "static/media/MUNISH VERMA.46adb93d.jpg";